/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchFilterDailyRate
 */
export interface SourcingSearchFilterDailyRate {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchFilterDailyRate
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterDailyRate
     */
    minDailyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterDailyRate
     */
    maxDailyRate?: number;
}

/**
 * Check if a given object implements the SourcingSearchFilterDailyRate interface.
 */
export function instanceOfSourcingSearchFilterDailyRate(value: object): value is SourcingSearchFilterDailyRate {
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function SourcingSearchFilterDailyRateFromJSON(json: any): SourcingSearchFilterDailyRate {
    return SourcingSearchFilterDailyRateFromJSONTyped(json, false);
}

export function SourcingSearchFilterDailyRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFilterDailyRate {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'minDailyRate': json['minDailyRate'] == null ? undefined : json['minDailyRate'],
        'maxDailyRate': json['maxDailyRate'] == null ? undefined : json['maxDailyRate'],
    };
}

export function SourcingSearchFilterDailyRateToJSON(value?: SourcingSearchFilterDailyRate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currencyCode': value['currencyCode'],
        'minDailyRate': value['minDailyRate'],
        'maxDailyRate': value['maxDailyRate'],
    };
}

